import { Box, Button, Grid, makeStyles } from '@material-ui/core'
import React, { useEffect, useState, useRef } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { HeaderBlock } from '../../components/header-block/HeaderBlock'
import ListableCard from '../../components/listable-card/ListableCard'
import { Loading } from '../../components/loading/Loading'
import PageContainer from '../../components/page-container/PageContainer'
import GenericPickerModal from '../../containers/generic-picker-modal/GenericPickerModal'
import { getAdministrators, updateAdministrators } from '../../state/actions/DistributorsAction'
import { getOutOfStockProducts, updateOutOfStockList } from '../../state/actions/OutOfStockActions'
import { getProducts, getProductsForIds } from '../../state/actions/ProductActions'
import { getTargetGroup, resetLocalTargetGroup } from '../../state/actions/TargetGroupActions'
import { getUsers, GET_USER_SIZE, getUsersById, clearUsers } from '../../state/actions/UserActions'
import { DeleteModal } from '../../containers/delete-modal/DeleteModal'
import { useTranslation } from 'react-i18next'
import { SalesOrgIds } from 'state/constants/SalesOrgIds'
import ProductPickerModal from 'containers/generic-picker-modal/ProductPickerModal'

const useStyles = makeStyles({
    listableCard: {
        padding: "30px"
    }
})

function DistributionPage(props) {
    const distributor = useSelector(state => state.TargetGroupReducer.currentTargetGroup)
    const administrators = useSelector(state => state.DistributorReducer.administrators)
    const outOfStock = useSelector(state => state.OutOfStockReducer.currentOutOfStockList)
    const users = useSelector(state => state.UserReducer.users)
    const products = useSelector(state => state.ProductReducer.products)
    const continuationToken = useSelector(state => state.UserReducer.continuationToken)
    const assignedUsers = useSelector(state => state.UserReducer.assignedUsers)

    const [t, i18n] = useTranslation()
    const dispatch = useDispatch()
    const classes = useStyles()

    const [loading, setLoading] = useState(false)
    const [loadingOutOfStock, setLoadingOutOfStock] = useState(false)
    const [loadingAdministrators, setLoadingAdministrators] = useState(false)
    const [addAdministratorModalOpen, setAddAdministratorModalOpen] = useState(false)
    const [addOutOfStockModalOpen, setAddOutOfStockModalOpen] = useState(false)
    const [deleteAdministratorModaOpen, setDeleteAdministratorModaOpen] = useState(false)
    const [deleteOutOfStockModalOpen, setDeleteOutOfStockModalOpen] = useState(false)
    const [administratorsToDelete, setAdministratorsToDelete] = useState([])
    const [outOfStockToDelete, setOutOfStockToDelete] = useState([])
    const [newAdministratorData, setNewAdministratorData] = useState(false)
    const [newOutOfStockData, setNewOutOfStockData] = useState(false)
    const [fetchAssignedUsers, setFetchAssignedUsers] = useState(false)

    const [hasNewData, setHasNewData] = useState(true)
    const [firstUserFetch, setFirstUserFetch] = useState(true)
    const [loadingUsers, setLoadingUsers] = useState(false)
    const [lastSearch, setLastSearch] = useState("")

    useEffect(() => {
        setLoading(true)
        setLoadingOutOfStock(true)
        const targetGroupId = props.match.params.targetGroupId
        dispatch(getTargetGroup(targetGroupId, () => {
            setLoading(false)
        }))

        dispatch(getAdministrators(targetGroupId, () => {
            setFetchAssignedUsers(true)
        }))

        dispatch(getOutOfStockProducts(targetGroupId, () => {

        }))
        return () => {
            dispatch(resetLocalTargetGroup(() => { }))
        }
    }, [])

    useEffect(() => {
        const searchData = continuationToken?.search != null
        const baseData = continuationToken?.base != null

        setHasNewData(searchData || baseData)
        if (!searchData) {
            setLastSearch("")
        }
    }, [continuationToken])

    useEffect(() => {
        if (addAdministratorModalOpen == false) {
            return () => {
                dispatch(clearUsers(() => { }))
            }
        }
    }, [addAdministratorModalOpen])

    useEffect(() => {
        const administratorList = Object.values(administrators || {})

        if (fetchAssignedUsers === true && administratorList.length > 0) {
            setLoadingAdministrators(true)

            dispatch(getUsersById(administratorList, () => {
                setLoadingAdministrators(false)
                setFetchAssignedUsers(false)
            }))
        } else {
            setFetchAssignedUsers(false)
        }
    }, [fetchAssignedUsers])

    useEffect(() => {
        setLoadingOutOfStock(true)
        dispatch(getProductsForIds(outOfStock, () => {
            setLoadingOutOfStock(false)
        }))
    }, [outOfStock])

    useEffect(() => {
        if (newAdministratorData === true) {
            setLoadingAdministrators(true)
            dispatch(getAdministrators(distributor.id, () => {
                setLoadingAdministrators(false)
                setNewAdministratorData(false)
                setFetchAssignedUsers(true)
            }))
        }
    }, [newAdministratorData])

    useEffect(() => {
        if (newOutOfStockData === true) {
            setLoadingOutOfStock(true)
            dispatch(getOutOfStockProducts(distributor.id, () => {
                setLoadingOutOfStock(false)
                setNewOutOfStockData(false)
            }))
        }
    }, [newOutOfStockData])

    function handleAdministratorSelection(administratorList) {
        const values = administratorList

        const data = {
            DistributorId: distributor.id,
            UserIds: values
        }

        setAddAdministratorModalOpen(false)

        dispatch(updateAdministrators(data, () => {
            setNewAdministratorData(true)
        }))
    }

    function handleOutOfStockSelection(outOfStockList) {
        const values = Object.values(outOfStock).concat(outOfStockList)

        const data = {
            DistributorId: distributor.id,
            ProductIds: values
        }

        setAddOutOfStockModalOpen(false)

        dispatch(updateOutOfStockList(data, () => {
            setNewOutOfStockData(true)

        }))
    }

    function handleAdministratorDeletion(administratorList) {
        const itemIds = administratorList.map(item => item.id);
        const values = Object.values(administrators).filter(value => !itemIds.includes(value));

        const data = {
            DistributorId: distributor.id,
            UserIds: values
        }

        setDeleteAdministratorModaOpen(false)

        dispatch(updateAdministrators(data, () => {
            setNewAdministratorData(true)
        }))
    }

    function handleOutOfStockDeletion(outOfStockList) {
        const itemIds = outOfStockList.map(item => item.id);
        const values = Object.values(outOfStock).filter(value => !itemIds.includes(value));

        const data = {
            DistributorId: distributor.id,
            ProductIds: values
        }

        setDeleteOutOfStockModalOpen(false)

        dispatch(updateOutOfStockList(data, () => {
            setNewOutOfStockData(true)
        }))
    }

    function getAdministratorList(administratorIds) {

        if (administratorIds !== undefined) {
            return administratorIds.map(administratorIds => {
                const administrator = assignedUsers[administratorIds];

                if (administrator !== undefined) {
                    return { id: administrator.id, Name: administrator.name || administrator.displayName };
                }

                return { id: administratorIds, Name: "Bad User Data", notClickable: true };
            });
        }

        return [];
    }

    function getOutOfStockProductList(productIds) {

        if (productIds !== undefined) {
            return productIds.map(productId => {
                const outOfStockItem = products[productId];

                if (outOfStockItem !== undefined) {
                    return { id: outOfStockItem.id, Name: outOfStockItem.ProductDisplayName != null ? outOfStockItem.ProductDisplayName : outOfStockItem.ProductName };
                }

                return {};
            });
        }

        return [];
    }

    function getNextPage(value = "") {
        var searchValue = value
        if (value == "" && lastSearch != "" && continuationToken?.search != null) {
            searchValue = lastSearch
        }

        if (value != "") {
            setLastSearch(value)
        }

        let promiseResolver

        dispatch(getUsers(() => {
            setFirstUserFetch(false)
            setLoadingUsers(false)
            promiseResolver()

        }, GET_USER_SIZE.LARGE, searchValue != "" ? continuationToken?.search : continuationToken?.base, searchValue, searchValue == ""))

        return new Promise((resolve) => {
            promiseResolver = resolve
            setLoadingUsers(true)
        })
    }

    function handleAdministratorCancel() {
        setFirstUserFetch(true)
        setAddAdministratorModalOpen(false)
    }

    function renderData() {
        return <Box className={classes.contentGrid}>
            <Grid container spacing={3} className={classes.listableCard}>
                <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
                    <ListableCard
                        actionButton={[
                            <Button
                                onClick={() => {
                                    setAddAdministratorModalOpen(true)
                                }}
                                variant="outlined"
                                color="secondary"
                            >
                                {t("distributor.add-admin")}
                            </Button>
                        ]}
                        primaryId={["id"]}
                        title={t("distributor.assigned-admin")}
                        emptyPlaceholder={t("distributor.no-admin")}
                        handleDelete={administratorsToDelete => {
                            setDeleteAdministratorModaOpen(true)
                            setAdministratorsToDelete(administratorsToDelete)
                        }}
                        onClick={userId =>
                            props.history.push(`/users/${userId}`)
                        }
                        data={getAdministratorList(Object.values(administrators))}
                        isLoading={loadingAdministrators}
                    />
                </Grid>
                <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
                    <ListableCard
                        actionButton={[
                            <Button
                                onClick={() => setAddOutOfStockModalOpen(true)}
                                variant="outlined"
                                color="secondary"
                            >
                                {t("distributor.add-product")}
                            </Button>
                        ]}
                        primaryId={["id"]}
                        title={t("oos.oos-list")}
                        emptyPlaceholder={t('distributor.no-oos')}
                        handleDelete={outOfStockToDelete => {
                            setDeleteOutOfStockModalOpen(true)
                            setOutOfStockToDelete(outOfStockToDelete)
                        }}
                        onClick={productId =>
                            props.history.push(`/products/${productId}`)
                        }
                        data={getOutOfStockProductList(Object.values(outOfStock))}
                        isLoading={loadingOutOfStock}
                    />
                </Grid>
            </Grid>
        </Box>
    }

    return (
        <Box>
            {loading ? <Loading /> :
                <Box>
                    <HeaderBlock
                        title={distributor.DisplayName}
                    />

                    <GenericPickerModal
                        handleCancel={handleAdministratorCancel}
                        handleDone={selectedAdministrators => handleAdministratorSelection(selectedAdministrators)}
                        open={addAdministratorModalOpen}
                        selected={Object.values(administrators)}
                        currentSelection={Object.values(administrators)}
                        getAllData={(callback) => dispatch(getUsers(callback))}
                        searchTitle={t('distributor.search-admin')}
                        title={t('distributor.admin')}
                        data={Object.values(users)}
                        idField="id"
                        valueField="name"

                        infiniteLoading
                        hasNextPage={hasNewData || firstUserFetch}
                        isNextPageLoading={loadingUsers}
                        loadNextPage={getNextPage}
                    />

                    <ProductPickerModal
                        handleProductSelection={selectedProducts => handleOutOfStockSelection(selectedProducts)}
                        productModalOpen={addOutOfStockModalOpen}
                        selected={Object.values(outOfStock)}
                        setProductModalOpen={() => setAddOutOfStockModalOpen(false)}
                    />

                    <DeleteModal
                        handleCancel={() => {
                            setDeleteAdministratorModaOpen(false)
                            setAdministratorsToDelete([])
                        }}
                        handleDone={data => {
                            handleAdministratorDeletion(data);
                        }}
                        data={getAdministratorList(administratorsToDelete)}
                        open={deleteAdministratorModaOpen}
                    />

                    <DeleteModal
                        handleCancel={() => {
                            setDeleteOutOfStockModalOpen(false)
                            setOutOfStockToDelete([])
                        }}
                        handleDone={data => {
                            handleOutOfStockDeletion(data);
                        }}
                        data={getOutOfStockProductList(outOfStockToDelete)}
                        open={deleteOutOfStockModalOpen}
                    />

                    <PageContainer>
                        {renderData()}
                    </PageContainer>
                </Box>
            }
        </Box>
    )
}

DistributionPage.propTypes = {

}

export default DistributionPage

